import React, { useEffect, useState } from 'react';
import './Archive.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Navbar } from 'react-bootstrap';
import { getCustomerArchive } from '../../service/customerService';
import Customer from './Customer';
import LicenseGeneratorModal from '../License/LicenseGenerator';
import DecsriptionModal from '../License/Decsription';
import PaymentModal from '../License/Payment';
import DeleteModal from './DeleteModal';
import ShowMenuModal from '../License/ShowMenu';
import SmsPanelModal from './SmsPanelModal';

const Archive = () => {


    let navigate = useNavigate();
    const { state } = useLocation();
    const [customers, setCustomers] = useState();
    const [lastCompany, setLastCompany] = useState();
    const [showLicenseModal, setShowLicenseModal] = useState(false);
    const [selectCustomerForLicense, setSelectCustomerForLicense] = useState();
    const [showSmsPanelModal, setShowSmsPanelModal] = useState(false);
    const [selectCustomerForSmsPanel, setSelectCustomerForSmsPanel] = useState();
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [selectCustomerForInfo, setSelectCustomerForInfo] = useState();
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [selectCustomerForPayment, setSelectCustomerForPayment] = useState();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectCustomerForDelete, setSelectCustomerForDelete] = useState();
    const [showMenuModal, setShowMenuModal] = useState(false);
    const [selectCustomerForMenu, setSelectCustomerForMenu] = useState();
    const perPage = 33;
    const [endArchive, setEndArchive] = useState(false);

    useEffect(() => {
        if (!state || !state.person) {
            return navigate("/", { replace: true });
        }
        const fetchAllProducts = async () => {
            try {
                const params = {
                    lastCompany,
                    perPage,
                    groupType: state.type
                }
                let { status, data } = await getCustomerArchive(params);
                if (status === 201) {
                    setCustomers(prev => prev ? prev.concat(data.customers) : data.customers);
                    if (data.customers.length < perPage) {
                        setEndArchive(true);
                    }
                }
            } catch (err) {
            }
        }

        fetchAllProducts();


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastCompany]);

    useEffect(() => {
        if (selectCustomerForLicense) {
            setShowLicenseModal(true);
        }
        else {
            setShowLicenseModal(false);
        }
    }, [selectCustomerForLicense])

    useEffect(() => {
        if (selectCustomerForSmsPanel) {
            setShowSmsPanelModal(true);
        }
        else {
            setShowSmsPanelModal(false);
        }
    }, [selectCustomerForSmsPanel])

    useEffect(() => {
        if (selectCustomerForInfo) {
            setShowInfoModal(true);
        }
        else {
            setShowInfoModal(false);
        }
    }, [selectCustomerForInfo])

    useEffect(() => {
        if (selectCustomerForPayment) {
            setShowPaymentModal(true);
        }
        else {
            setShowPaymentModal(false);
        }
    }, [selectCustomerForPayment])

    useEffect(() => {
        if (selectCustomerForDelete) {
            setShowDeleteModal(true);
        }
        else {
            setShowDeleteModal(false);
        }
    }, [selectCustomerForDelete])

    useEffect(() => {
        if (selectCustomerForMenu) {
            setShowMenuModal(true);
        }
        else {
            setShowMenuModal(false);
        }
    }, [selectCustomerForMenu])


    if (!state || !state.person) {
        return navigate("/", { replace: true });
    }

    const handleNewLicense = (companyName, newLicense, newCustomerCode, newExpireTimeStamp) => {
        try {
            let currentCustomers = [...customers];
            let index = currentCustomers.findIndex(item => item.companyName === companyName);
            if (index > -1) {
                currentCustomers[index].license = newLicense;
                currentCustomers[index].subscriptionNumber = newCustomerCode;
                currentCustomers[index].expireTimeStamp = newExpireTimeStamp;
                setCustomers(currentCustomers)
            }
        } catch (err) {
        }
    }
    const handleNewInfo = (companyName, newInfo) => {
        try {
            let currentCustomers = [...customers];
            let index = currentCustomers.findIndex(item => item.companyName === companyName);
            if (index > -1) {
                currentCustomers[index].info = newInfo;
                setCustomers(currentCustomers)
            }
        } catch (err) {
        }
    }
    const handleNewPayment = (companyName, newPayment) => {
        try {
            let currentCustomers = [...customers];
            let index = currentCustomers.findIndex(item => item.companyName === companyName);
            if (index > -1) {
                currentCustomers[index].payment = newPayment;
                setCustomers(currentCustomers)
            }
        } catch (err) {
        }
    }
    const handleNewSmsInfo = (companyName, params) => {
        try {
            let currentCustomers = [...customers];
            let index = currentCustomers.findIndex(item => item.companyName === companyName);
            if (index > -1) {
                currentCustomers[index].sms = {
                    wallet: currentCustomers[index].sms.wallet + params.addedPrice,
                    count: currentCustomers[index].sms.count,
                    driverRemain: params.templatesObj.driverRemain,
                    addDriverFish: params.templatesObj.addDriverFish,
                    reduceDriverFish: params.templatesObj.reduceDriverFish,
                    customerMembership: params.templatesObj.customerMembership
                };

                setCustomers(currentCustomers)
            }
        } catch (err) {
        }
    }

    return (
        <div>
            <Navbar
                variant={state.type === 'active' ? 'dark' : state.type === 'deActive' ? 'dark' : 'light'}
                bg={state.type === 'active' ? 'success' : state.type === 'deActive' ? 'danger' : 'warning'}
                data-bs-theme={state.type === 'active' ? 'dark' : state.type === 'deActive' ? 'dark' : 'light'}
                sticky="top"
                dir='rtl'
            >
                <Container>
                    <Navbar.Brand onClick={() => navigate(-1)}>
                        <i className='fa fa-arrow-right mr-3'></i>
                    </Navbar.Brand>
                    <Navbar.Brand style={{ fontSize: '1rem', marginLeft: 'auto' }}>
                        {state.type === 'active' ? 'مشتری های فعال' : state.type === 'deActive' ? 'مشتری های غیر فعال' : 'تمدیدی های پیش رو'}
                    </Navbar.Brand>
                </Container>
            </Navbar>

            {
                customers && customers.map((element, index) =>
                    <Customer
                        number={index + 1}
                        color={state.type === 'active' ? 'success' : state.type === 'deActive' ? 'danger' : 'warning'}
                        customer={element}
                        key={element.companyName}
                        admin={state.person}
                        setCustomerForLicense={() => setSelectCustomerForLicense(element)}
                        setCustomerForInfo={() => setSelectCustomerForInfo(element)}
                        setCustomerForSmsPanel={() => setSelectCustomerForSmsPanel(element)}
                        setCustomerForPayment={() => setSelectCustomerForPayment(element)}
                        setCustomerForDelete={() => setSelectCustomerForDelete(element)}
                        setCustomerForMenu={() => setSelectCustomerForMenu(element)}
                    />
                )
            }
            <div className='rtl px-3'>
                <button className='btn btn-dark mb-5' style={{ display: endArchive ? 'none' : 'initial' }}
                    onClick={() => setLastCompany(customers[customers.length - 1].companyName)}
                >
                    <i className='fa fa-chevron-circle-down mr-2'></i>مشاهده بیشتر
                </button>
            </div>
            <LicenseGeneratorModal
                showModal={showLicenseModal}
                handleClose={() => setSelectCustomerForLicense()}
                customer={selectCustomerForLicense}
                admin={state.person}
                setNewLicense={handleNewLicense}
            />
            <DecsriptionModal
                showModal={showInfoModal}
                handleClose={() => setSelectCustomerForInfo()}
                customer={selectCustomerForInfo}
                admin={state.person}
                setNewInfo={handleNewInfo}
            />
            <SmsPanelModal
                showModal={showSmsPanelModal}
                handleClose={() => setSelectCustomerForSmsPanel()}
                customer={selectCustomerForSmsPanel}
                admin={state.person}
                setNewSmsInfo={handleNewSmsInfo}
            />
            <PaymentModal
                showModal={showPaymentModal}
                handleClose={() => setSelectCustomerForPayment()}
                customer={selectCustomerForPayment}
                admin={state.person}
                setNewPayment={handleNewPayment}
            />
            <DeleteModal
                handleClose={() => setSelectCustomerForDelete()}
                show={showDeleteModal}
                customer={selectCustomerForDelete}
                admin={state.person}
                setCustomers={setCustomers}
            />
            <ShowMenuModal
                handleClose={() => setSelectCustomerForMenu()}
                showModal={showMenuModal}
                customer={selectCustomerForMenu}
            />
        </div>
    );
}

export default Archive;